'use strict';

var $backToTopIcon = $('.back-to-top-container .icon');

$(document).ready(function () {
    $backToTopIcon.on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow'); // Smooth scrolling
        return false;
    });
});
